import { formatActivityDateAndTimes } from "web_myplann/Activities/Utils/formatActivityDateAndTimes";
import {
	TimelineItemCategoryEnum,
	type TimelineItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	type useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { TimelineDateLines } from "web_myplann/NotificationCenter/Types/TimelineDateLines";
import { TimelineDateStyle } from "web_myplann/NotificationCenter/Types/TimelineDateStyle";
import {
	formatRelativeTimelineDate,
	formatTimelineDate,
	formatTimelineTimeRange,
} from "web_myplann/NotificationCenter/Utils/formatTimelineDate";
import { formatTimelineSpacedDate } from "web_myplann/NotificationCenter/Utils/formatTimelineSpacedDate";
import { isResolvedActivityMovedToToday } from "web_myplann/NotificationCenter/Utils/isResolvedActivityMovedToToday";
import { parseActivityData } from "web_myplann/NotificationCenter/Utils/parseActivityData";

type TranslateFn = ReturnType<typeof useResource>["t"];

export const mapTimelineEntryDateLines = (
	item: TimelineItemResponseDTO,
	dateStyle: TimelineDateStyle,
	t: TranslateFn,
	hasGoalsRight: boolean,
): TimelineDateLines => {
	const timeTo =
		item.category === TimelineItemCategoryEnum.Activity
			? parseActivityData(item.data)?.timeTo
			: undefined;

	if (isResolvedActivityMovedToToday(item)) {
		return { dateLine: t(Resources.NotificationCenter.RecentGroups.Today) };
	}

	if (hasGoalsRight && item.category === TimelineItemCategoryEnum.Activity) {
		return {
			dateLine: formatActivityDateAndTimes(item.date, item.time, timeTo),
		};
	}

	const relativeDate =
		dateStyle === TimelineDateStyle.Relative
			? formatRelativeTimelineDate(item.date, new Date(), {
					today: t(Resources.Notifications.Date.today),
					yesterday: t(Resources.Notifications.Date.daysAgo, { count: 1 }),
					daysAgo: (count) =>
						t(Resources.Notifications.Date.daysAgo, { count }),
				})
			: undefined;

	if (hasGoalsRight) {
		return { dateLine: relativeDate ?? formatTimelineSpacedDate(item.date) };
	}

	return {
		dateLine: relativeDate ?? formatTimelineDate(item.date),
		secondaryDateLine: item.time
			? formatTimelineTimeRange(item.time, timeTo)
			: undefined,
	};
};
